import React, { useRef, useEffect } from 'react';

export const PortfolioGallery = () => {
  const trackRef = useRef(null);

  const portfolioImages = [
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/c4gllkb1_WhatsApp%20Image%202026-03-10%20at%202.50.43%20PM.jpeg",
      alt: "E-Rickshaw Mobile Advertising - Yellow Vehicle NID NIFT Coaching"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/19jockuz_WhatsApp%20Image%202026-03-10%20at%202.50.48%20PM.jpeg",
      alt: "E-Rickshaw Mobile Advertising - NID NIFT NATA Coaching"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/dfp6u0lb_WhatsApp%20Image%202026-03-10%20at%202.56.33%20PM.jpeg",
      alt: "E-Rickshaw Advertising Campaign - Design Studio"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/znsk8rvm_WhatsApp%20Image%202026-03-10%20at%202.50.30%20PM.jpeg",
      alt: "Mobile Advertising E-Rickshaw - Career Coaching"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/w93iiee0_WhatsApp%20Image%202026-03-10%20at%202.42.14%20PM.jpeg",
      alt: "E-Rickshaw Branding - Educational Services"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/8cje2znk_E%20Rikshwa.jpeg",
      alt: "E-Rickshaw Advertising - Street Campaign"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/oqrdzzu7_Fm.jpeg",
      alt: "FM Radio Advertising Billboard"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/95v9lmnq_Gemini_Generated_Image_fhbqqofhbqqofhbq.png",
      alt: "Street Advertising Campaign"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/6j2qolzb_Holograpy.jpeg",
      alt: "Holographic Advertising Display"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/ybapjz9h_Local%20Tv%20Channel.jpeg",
      alt: "Local TV Channel Advertising"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/jr1ipvbn_Mobile%20vhan.jpeg",
      alt: "Mobile Van Branding Campaign"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/n0n7zpy3_Google%20Photography.jpeg",
      alt: "Google Business Photography Service"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_insmart-media/artifacts/2rr0ek09_Gemini_Generated_Image_fhbqqofhbqqofhbq%20%281%29.png",
      alt: "Road Arch Welcome Gate Campaign"
    }
  ];

  // Duplicate images twice for seamless infinite scroll
  const allImages = [...portfolioImages, ...portfolioImages];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationId;
    let position = 0;

    const animate = () => {
      position -= 0.5; // Smooth, consistent speed
      
      // Calculate when to reset (after first set of images passes)
      const imageWidth = 288; // 320px width + 24px gap (md:w-80 + md:gap-6)
      const resetPoint = -(imageWidth * portfolioImages.length);
      
      if (position <= resetPoint) {
        position = 0;
      }
      
      track.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [portfolioImages.length]);

  return (
    <section className="py-12 md:py-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 md:mb-12">
        <div className="text-center">
          <div className="mb-6">
            <p className="text-2xl md:text-3xl font-bold text-gray-700 italic mb-2">
              "Advertising is Not an Expense..."
            </p>
            <p className="text-3xl md:text-4xl font-bold text-blue-600">
              It is Investment in Growth
            </p>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            Our <span className="text-blue-600">Portfolio</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-2">
            Real campaigns, real results - See our work in action
          </p>
        </div>
      </div>

      {/* Seamless Infinite Scrolling Gallery */}
      <div className="relative w-full overflow-hidden">
        <div 
          ref={trackRef}
          className="flex gap-4 md:gap-6 will-change-transform"
          style={{ display: 'flex', whiteSpace: 'nowrap' }}
        >
          {allImages.map((image, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-64 md:w-80 h-48 md:h-64 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
